import { Datepicker } from "@zendeskgarden/react-datepickers";
import {
  Dropdown,
  Field as FieldDropdown,
  Item,
  Menu,
  Select,
} from "@zendeskgarden/react-dropdowns";
import {
  Toggle,
  Label,
  Input,
  Field,
  Field as ToggleField,
  Message
} from "@zendeskgarden/react-forms";
import { ThemeProvider } from "@zendeskgarden/react-theming";
import { theme } from "../../../util/colorButton";
import { Col, Row } from "@zendeskgarden/react-grid";
import { EditorState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import { stateFromHTML } from "draft-js-import-html";
import { Editor } from "react-draft-wysiwyg";
// @ts-ignore 
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import React from "react";
import { connect } from "react-redux";
import Loading from "../../../components/loading";
import { AccordionContainer } from "@zendeskgarden/container-accordion";
import ReactComponents from "../../../images/enter-loading.png";
import UserService from "../../../services/user.service";
import { setUtcZero } from "../../../util/date";
import Moment from "moment";
import { UserData } from "../../../model/user.model";
import { ReactComponent as UserIcon } from "../../../images/icons/ic_done_black_24px.svg";
import { ReactComponent as TooltipInfo } from "../../../images/icons/info.svg";
import { Tooltip } from "@zendeskgarden/react-tooltips";
import {
  Opportunity,
  OpportunityFields,
  Steps,
} from "../../../model/opportunity.model";
import {
  getOpStatus,
  getOpCapture,
  getOpSource,
  getCurrentObject,
  getInfoStep,
  evaluationTypeOptions,
} from "../../../util/opportunity";
import { t } from "../../../translations/translation.service";
// @ts-ignore
import "./index.css";
import OpportunityService from "../../../services/opportunity.service";
import { AlertService } from "../../../services/alert.service";
import { AuthenticationService } from "../../../services/auth.service";
import { Link } from "react-router-dom";
import ReactGA from 'react-ga4';
import FileStackService from "../../../services/filestack.service";

const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
});

const OpportunityStatus: OpportunityFields[] = getOpStatus();
const OpportunityCapture: OpportunityFields[] = getOpCapture();
const OpportunitySource: OpportunityFields[] = getOpSource();

class OpportunityProgress extends React.Component<any> {
  state = {
    loading: true,
    opportunity: {} as Opportunity,
    user: {} as UserData,
    recruiter: {} as UserData,
    dataCandidatura: new Date(),
    sections: [] as Steps[],
    status: {} as OpportunityFields,
    capture: {} as OpportunityFields,
    source: {} as OpportunityFields,
    dateVictory: new Date(), // For 'Selecionado' status (id: 6)
    dateRefused: new Date(), // For 'Recusou' status (id: 4)
    dateQuit: new Date(),    // For 'Desistiu' status (id: 5)
    calendarDateStart: new Date(),
    isInvalidDate: false,
    policyAndSignatureImg: '' as string,
    fieldsLocked: false,
    statusDetails: "",
    expandedItems: [] as number[],
  };

  constructor(props: any) {
    super(props);
    this.changeProfessionalInfo = this.changeProfessionalInfo.bind(this);
    this.clear = this.clear.bind(this);
    this.parseDateBr = this.parseDateBr.bind(this);
  }

  async componentDidMount() {
    const oppPeriods = await OpportunityService.getOpportunityDates(this.props.match.params.opportunityId);
    const { data } = await OpportunityService.getOpWithCandidate(
      this.props.match.params.opportunityId,
      this.props.match.params.professionalId
    );
    const indexCapture = getCurrentObject(
      OpportunityCapture,
      data.vaga.candidatos[0].capture
    );
    const indexSource = getCurrentObject(
      OpportunitySource,
      data.vaga.candidatos[0].source
    );

    if (data.vaga.candidatos[0].recruiter) {
      const recruiter = await UserService.getUser(data.vaga.candidatos[0].recruiter);
      this.setState({ recruiter: recruiter.data });
    }

    const steps = data.vaga.candidatos[0].steps;
    steps.map((item: any) => {
      if (item.details && item.details !== "") {
        let contentState = stateFromHTML(item.details);
        item.details = EditorState.createWithContent(contentState);
      }
      return item;
    });
    const currentStatus = OpportunityStatus[data.vaga.candidatos[0].status.current];

    const dateVictory = new Date(data.vaga.candidatos[0].dateVictory ?? undefined);
    const dateRefused = new Date(data.vaga.candidatos[0].dateRefused ?? undefined);
    const dateQuit = new Date(data.vaga.candidatos[0].dateQuit ?? undefined);

    const hasDateVictory = dateVictory && dateVictory.toString() !== 'Invalid Date';
    const hasDateRefused = dateRefused && dateRefused.toString() !== 'Invalid Date';
    const hasDateQuit = dateQuit && dateQuit.toString() !== 'Invalid Date';

    const fieldsLocked = (
      (currentStatus.id === 6 && hasDateVictory) ||
      (currentStatus.id === 4 && hasDateRefused) ||
      (currentStatus.id === 5 && hasDateQuit)
    );

    this.setState({
      opportunity: data.vaga,
      user: data.candidato,
      dataCandidatura: data.vaga.candidatos[0].createdAt,
      sections: steps,
      loading: false,
      status: currentStatus,
      capture: OpportunityCapture[indexCapture],
      source: OpportunitySource[indexSource],
      dateVictory: hasDateVictory ? dateVictory : new Date(),
      dateRefused: hasDateRefused ? dateRefused : undefined,
      dateQuit: hasDateQuit ? dateQuit : undefined,
      calendarDateStart: this.setTimeZoneDefaut(new Date(oppPeriods.data.periods[0].dates[0].end)),
      fieldsLocked: fieldsLocked
    }, () => {
      const index = this.getCurrentStepIndex();

      this.setState(
        {
          expandedItems: [index]
        },
        () => {
          setTimeout(() => {
            const element = document.getElementById(`step-${index}`);
            if (element) {
              element.scrollIntoView({
                behavior: "smooth",
                block: "center"
              });
            }
          }, 300);
        }
      );

      this.getFileStackPolicyToUserImg();
    });
  }

  async getFileStackPolicyToUserImg(): Promise<void> {
    try {
      if (
        this.state.user &&
        this.state.user.userImageUrl &&
        this.getNewFileStackUrl(this.state.user.userImageUrl)
      ) {
        const policyUserImg = await FileStackService.getFileStackSecreteCode(
          this.state.user.userImageUrl, false
        );
        this.setState({ policyAndSignatureImg: policyUserImg.data });
      }
    } catch (err: any) {
      console.log("Erro ao obter credenciais - ERROR: ", err);
    }
  }

  getNewFileStackUrl(url: string): boolean {
    const domain = url.split('/')[2];
    if (domain.includes('cdn.file')) {
      return true;
    }
    return false;
  }

  setUrlImg(url: string): string {
    const { policyAndSignatureImg } = this.state;
    const splitedUrl = url.split('/');
    const newUrl = `https://${splitedUrl[2]}${policyAndSignatureImg}/${splitedUrl[splitedUrl.length - 1]}`
    return newUrl;
  }

  clear(key: any) {
    this.setState((previousState: any) => {
      let sections = [...previousState.sections];
      if (sections[key].user) {
        sections.forEach((section, index) => {
          if (index >= key) {
            section.date = undefined;
            section.meetsTheRequirements = undefined;
            section.details = "";
          }
        })
        return { sections };
      } else {
        sections[key] = {
          _id: sections[key]._id,
          key: key,
        };
        return { sections };
      }
    }, () => {
      this.changeStepCandidate(key);
    });

  }

  selectProfessionalEvent() {
    ReactGA.event({
      category: "Recruitment-actions",
      action: "selecionar profissional",
      label: "rh",
    })
  }

  reactVictoryEvent() {
    ReactGA.event({
      category: 'Recruitment-actions',
      action: "Vitória na oportunidade",
      label: "rh",
    })
  }

  async changeProfessionalInfo() {
    this.setState({ loading: true });
    try {

      let statusDetails = "";
      if (
        typeof this.state.statusDetails === "object" &&
        this.state.statusDetails !== null &&
        typeof (this.state.statusDetails as EditorState).getCurrentContent === "function"
      ) {
        statusDetails = stateToHTML((this.state.statusDetails as EditorState).getCurrentContent());
      } else if (typeof this.state.statusDetails === "string") {
        statusDetails = this.state.statusDetails;
      }
      const obj = {
        candidate: this.state.user._id,
        status: this.state.status.id,
        capture: this.state.capture?.id ? this.state.capture.id : "",
        source: this.state.source?.id ? this.state.source.id : "",
        dateVictory: this.state.status.id === 6 ? setUtcZero(this.state.dateVictory) : null,
        dateRefused: this.state.status.id === 4 ? setUtcZero(this.state.dateRefused) : null,
        dateQuit: this.state.status.id === 5 ? setUtcZero(this.state.dateQuit) : null,
        statusDetails: statusDetails,
      };


      //this.changeStepCandidate(0);

      await OpportunityService.changeInfoCandidate(
        this.state.opportunity._id,
        obj
      );
      if (this.state.status.id === 6) {
        this.selectProfessionalEvent();
        this.reactVictoryEvent();
        await UserService.becomeProfessionalEluminer(this.state.user._id);
      }

      this.setState({ loading: false });

      this.state.status.id === 6
        ? AlertService.success(
          t("O Candidato foi selecionado para a oportunidade!")
        )
        : AlertService.success(
          t("Informações do candidato alteradas com sucesso!")
        );
    } catch (err: unknown) {
      console.error("Error occurred:", err);
      AlertService.error(t("Não foi possível concluir a operação."));
    }
  }

  setTimeZoneDefaut = (date: Date): Date => {
    date?.setHours(12, 0, 0, 0);
    date = new Date(
      date.valueOf() - date.getTimezoneOffset() * 60000
    );
    return date;
  };

  getLastElementFromSections = (sections: Steps[]): Steps => {
    let section: Steps = {} as Steps;

    for (let index = sections.length - 1; index >= 0; index--) {
      if (sections[index].date && sections[index].meetsTheRequirements === 0) {
        section = sections[index];
        break;
      }
    }

    return section;
  }

  validateAndSaveDate = async (isSelection = false) => {
    const { dateVictory, dateRefused, dateQuit, calendarDateStart, sections, status } = this.state;

    let dateToValidate;
    if (status.id === 6) {
      dateToValidate = dateVictory;
    } else if (status.id === 4) {
      dateToValidate = dateRefused;
    } else if (status.id === 5) {
      dateToValidate = dateQuit;
    }

    if (!isSelection) {
      const currentStep = this.getLastElementFromSections(sections)

      if (Object.keys(currentStep).length < 1) {
        AlertService.warn(t("Não foi possível identificar a etapa atual do candidato."));
        return;
      }

      if (status.id === 4 && currentStep.key !== 4) {
        AlertService.warn(t("Todas as Etapas devem ser preenchidas para selecionar o status Recusou"));
        return;
      }

      if (
        !currentStep.details ||
        (
          currentStep.details.getCurrentContent &&
          currentStep.details.getCurrentContent().getPlainText().trim() === ""
        )
      ) {
        const stepName = getInfoStep(currentStep.key)?.sectionTitle || "";
        AlertService.warn(
          t("Preencha o campo de texto da etapa") +
          " " +
          stepName +
          " " +
          t("antes de marcar como") +
          " " +
          t(status.value) + "."
        );
        return;
      }
    }

    if (!dateToValidate) {
      AlertService.warn(t("Preencha o campo de") + " " + (isSelection ? t("Data da Seleção") : t("Data")) + " " + t("corretamente") + ".");
      return;
    }
    if (setUtcZero(Moment(dateToValidate).toDate()) < setUtcZero(Moment(calendarDateStart).toDate())) {
      AlertService.warn(t("Preencha o campo de") + " " + (isSelection ? t("Data da Seleção") : t("Data")) + " " + t("corretamente") + ".");
      return;
    }

    try {
      await this.changeProfessionalInfo();
      if (status.id === 6 || status.id === 5 || status.id === 4) {
        this.setState({ fieldsLocked: true });
      }
      AlertService.success(t("Data salva corretamente."));
    } catch (err) {
      console.error("Error saving date:", err);
      AlertService.error(t("Erro ao salvar a data. Tente novamente."));
    }
  };

  validateAndSaveDateVictory = () => this.validateAndSaveDate(true);

  validateAndSaveDateRecusouDesistiu = () => this.validateAndSaveDate(false);

  validationPresentationDate = () => {
    const stepPresention = this.state.sections[this.state.sections.length - 1];
    const hasFutureStepDate = stepPresention.date && new Date(stepPresention.date).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0);

    if (hasFutureStepDate) {
      AlertService.warn("Não é permitido selecionar o candidato com uma etapa registrada em data futura.");
      return true;
    }
    return false;
  };

  handleSaveButtonClick = async () => {
    const { status, statusDetails } = this.state;


    if (
      status.value === "Selecionado" ||
      status.value === "Recusou" ||
      status.value === "Desistiu"
    ) {

      let statusDetailText = "";
      if (
        typeof statusDetails === "object" &&
        statusDetails !== null &&
        typeof (statusDetails as EditorState).getCurrentContent === "function"
      ) {
        statusDetailText = (statusDetails as EditorState).getCurrentContent().getPlainText().trim();
      } else if (typeof statusDetails === "string") {
        statusDetailText = statusDetails.trim();
      }

      if (!statusDetailText) {
        AlertService.warn("Preencha o campo Detalhe do Status antes de salvar.");
        return;
      }
    }



    if (status.value === "Selecionado") {
      if (this.validationPresentationDate()) {
        return;
      }
      await this.validateAndSaveDateVictory();
    } else if (status.value === "Recusou" || status.value === "Desistiu") {
      await this.validateAndSaveDateRecusouDesistiu();
    } else {
      this.changeProfessionalInfo();
    }
  };

  updateSectionItem = (key: number, updates: Record<string, any>) => {
    this.setState((previousState: any) => {
      const sections = [...previousState.sections];
      sections[key] = {
        ...sections[key],
        ...updates
      };
      return { sections };
    });
  };

  renderPrimaryButton = (onClick: () => void, label: string) => {
    return (
      <button
        type="button"
        onClick={onClick}
        style={{
          background: "var(--color-secundario)",
          borderRadius: "15px",
          border: "none",
        }}
      >
        <span
          style={{
            color: "var(--color-white)",
            display: "inline-block",
            padding: ".25rem 2rem .25rem 2rem",
          }}
        >
          {t(label)}
        </span>
      </button>
    );
  };

  renderSecondaryButton = (onClick: () => void, label: string) => {
    return (
      <button
        type="button"
        className="mr-2"
        onClick={onClick}
        style={{
          background: "transparent",
          borderRadius: "15px",
          border: "1px solid var(--color-secundario)",
        }}
      >
        <span className="save-button-opp-progress">
          {t(label)}
        </span>
      </button>
    );
  };

  renderTextButton = (onClick: () => void, label: string) => {
    return (
      <button
        type="button"
        onClick={onClick}
        style={{
          border: "none",
          background: "transparent",
        }}
      >
        <span className="clean-button-opp-progress">
          {t(label)}
        </span>
      </button>
    );
  };

  handleEvaluationTypeChange = (key: number, value: string) => {
    this.updateSectionItem(key, { evaluationType: value });
  };

  renderEvaluationTypeField = (item: Steps) => {
    const selectedOption = evaluationTypeOptions.find(
      (option) => option.value === item.evaluationType
    );
    return (
      <ThemeProvider theme={theme as any}>
        <Dropdown
          selectedItem={selectedOption}
          onSelect={(option: { value: string; label: string }) =>
            this.handleEvaluationTypeChange(item.key, option.value)
          }
          downshiftProps={{
            itemToString: (option: { value: string; label: string }) =>
              option ? option.label : "",
          }}
        >
          <FieldDropdown className="mt-3 d-flex align-items-center">
            <Label
              className="accordion-font mr-2"
              style={{ flexShrink: 0 }}
            >
              {t("Tipo de avaliação")}
            </Label>
            <Select
              validation={!item.evaluationType ? "warning" : undefined}
              style={{ maxWidth: "220px" }}
              isCompact
            >
              {selectedOption ? t(selectedOption.label) : ""}
            </Select>
          </FieldDropdown>
          <Menu>
            {evaluationTypeOptions.map((option) => (
              <Item key={option.value} value={option}>
                {t(option.label)}
              </Item>
            ))}
          </Menu>
        </Dropdown>
        {!item.evaluationType && (
          <Field>
            <Message validation="error" className="mt-1">
              {t("Preencher o campo Tipo de Avaliação.")}
            </Message>
          </Field>
        )}
      </ThemeProvider>
    );
  };

  renderDateField = (labelText: string) => {
    const { status } = this.state;

    const minDate = status.id === 5
      ? (this.getCurrentStep(this.state.sections)
        ? Moment(this.getCurrentStep(this.state.sections).date).toDate()
        : new Date())
      : (this.getFinalStep(this.state.sections)
        ? Moment(this.getFinalStep(this.state.sections).date).toDate()
        : new Date());

    let currentDateValue;
    if (status.id === 6) {
      currentDateValue = this.state.dateVictory;
    } else if (status.id === 4) {
      currentDateValue = this.state.dateRefused;
    } else if (status.id === 5) {
      currentDateValue = this.state.dateQuit;
    }

    const isDateValid = currentDateValue && currentDateValue >= setUtcZero(Moment(this.state.calendarDateStart).toDate());

    return (
      <ThemeProvider theme={theme as any}>
        <Label className="mb-3">{t(labelText)}:</Label>
        <span>
          <Datepicker
            minValue={minDate}
            maxValue={new Date()}
            value={isDateValid ? currentDateValue : undefined}
            onChange={(date) => {
              if (this.state.fieldsLocked) {
                return;
              }
              if (this.isInvalid(date)) {
                AlertService.warn(t("Verifique a data ou se a etapa do candidato está preenchida."));
                return;
              }

              if (status.id === 6) {
                this.setState({ dateVictory: date });
              } else if (status.id === 4) {
                this.setState({ dateRefused: date });
              } else if (status.id === 5) {
                this.setState({ dateQuit: date });
              }
            }}
            onClick={() => {
              if (!this.state.fieldsLocked) {
                this.setState({ isInvalidDate: false });
              }
            }}
            formatDate={(date) => dateFormatter.format(date)}
            customParseDate={this.parseDateBr}
            isCompact
            locale="pt-BR"
          >
            <Input
              validation={this.state.isInvalidDate ? "error" : undefined}
              disabled={this.state.fieldsLocked}
            />
          </Datepicker>
        </span>
      </ThemeProvider>
    );
  };

  getOpportunityStep(step: number) {
    if (this.state.opportunity.isPublic) {
      if (
        this.state.opportunity.quantidadeVagas === 0 ||
        this.state.opportunity.victories !== 0 ||
        this.state.opportunity.defeats !== 0
      )
        return t("Encerrada");
      switch (step) {
        case 0:
          return t("Recrutamento");
        case 1:
          return t("Recrutamento");
        case 2:
          return t("Avaliação");
        case 3:
          return t("Seleção");
        case 4:
          return t("Apresentação");
      }
    } else {
      return t("Revisão");
    }
  }

  OpenNextStep = (currentKey: number) => {
    const currentIndex = this.state.sections.findIndex(
      (s: any) => s.key === currentKey
    );

    const nextIndex = currentIndex + 1;

    if (nextIndex < this.state.sections.length) {
      this.setState(
        {
          expandedItems: [nextIndex]
        },
        () => {
          setTimeout(() => {
            const element = document.getElementById(`step-${nextIndex}`);
            if (element) {
              element.scrollIntoView({
                behavior: "smooth",
                block: "center"
              });
            }
          }, 200);
        }
      );
    }
  };

  getCurrentStepIndex = () => {
    const { sections } = this.state;

    const currentStep = this.getCurrentStep(sections);

    if (!currentStep) return 0;

    const index = sections.findIndex(
      (s: any) => s.key === currentStep.key
    );


    return index + 1 < sections.length ? index + 1 : index;
  };

  async changeStepCandidate(step: number) {
    this.setState({ loading: true });
    try {
      if (this.state.opportunity.label === "2") {
        this.setState({ loading: false }, () =>
          AlertService.warn(
            t(
              "Esta oportunidade está inativa. Para fazer alterações na candidatura do profissional, ative a oportunidade antes."
            )
          )
        );
        return;
      }

      const { date, key, meetsTheRequirements, evaluationType } = this.state.sections[step];
      var stepsReq: any = [];
      if (!date) {
        this.setState({
          loading: false
        })
        AlertService.warn("Necessário o preenchimento da data.");
        return;
      }

      if (key === 2 && !evaluationType) {
        this.setState({ loading: false });
        AlertService.warn(t("Preencher o campo Tipo de Avaliação."));
        return;
      }

      this.state.sections.forEach((item: Steps) => {
        let step = { ...item, details: "" };
        if (item.details && item.details !== "") {
          step.details = stateToHTML(item.details.getCurrentContent());
        }

        if (step.user && step.user._id) step.user = step.user._id;
        if (step.key === key) {
          if (date) {
            step.date = new Date(date);
            step.date = this.setTimeZoneDefaut(step.date);
          } else {
            delete step.date;
          }
          step.user = AuthenticationService.getUser()._id;
          step.meetsTheRequirements = meetsTheRequirements;
          step.isChecked = true;
        }
        stepsReq.push(step);
      });

      const obj = {
        candidate: this.state.user._id,
        steps: stepsReq,
      };
      await OpportunityService.changeStepCandidate(
        this.state.opportunity._id,
        obj
      );
      this.setState({ loading: false });
      AlertService.success(t("Fases da candidatura salvas com sucesso!"));
      this.OpenNextStep(step);
    } catch (err) {
      this.setState({ loading: false });
      AlertService.error(t("Ocorreu algum erro. Tente novamente mais tarde."));
      console.error(err);
    }
  }

  parseDateBr(inputValue: string) {
    if (inputValue.length === 10) {
      const value = inputValue.split("/");
      const formatDateBR = `${value[1]}/${value[0]}/${value[2]}`;
      const data = new Date(formatDateBR);
      this.setState({ isInvalidDate: false })
      return data;
    }
    return new Date("");
  }

  getFinalStep = (section: any) => {
    let finalStep: any = {};
    for (let index = section.length - 1; index >= 0; index--) {
      if (section[index].key === 4 && section[index].meetsTheRequirements === 0) {
        finalStep = section[index];
        return finalStep;
      }
    }
    return null;
  }
  getCurrentStep = (sections: any) => {
    if (sections.length > 0) {
      const currentStep = sections.find((section: any) =>
        section.date && !sections.some((s: any) =>
          s.date && s.key > section.key && s.meetsTheRequirements !== undefined
        )
      );
      if (currentStep && currentStep.date) {
        return currentStep;
      }
    }
    return null;
  }




  isInvalid(date: Date) {
    const selectedDate = new Date(date).setHours(0, 0, 0, 0);
    const toDay = new Date(new Date()).setHours(0, 0, 0, 0);

    if (this.state.status.id === 5) {
      const currentStep = this.getCurrentStep(this.state.sections);
      if (currentStep) {
        const dateCurrentStep = new Date(currentStep.date).setHours(0, 0, 0, 0);
        if (selectedDate < dateCurrentStep || selectedDate > toDay) {
          this.setState({ isInvalidDate: true });
          return true;
        }
        this.setState({ isInvalidDate: false });
        return false;
      }
    } else {
      const finalDate = this.getFinalStep(this.state.sections);
      if (finalDate) {
        const dateLastStep = new Date(finalDate.date).setHours(0, 0, 0, 0);
        if (selectedDate < dateLastStep || selectedDate > toDay) {
          this.setState({ isInvalidDate: true });
          return true;
        }
        this.setState({ isInvalidDate: false });
        return false;
      }
    }

    return true;
  }

  getStartOfDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  getEvaluationDateRange(): { min: Date; max: Date } {
    const max = this.getStartOfDay(new Date());
    const min = new Date(max);
    min.setDate(min.getDate() - 7);

    return { min, max };
  }

  changeDate(date: Date, previousStep: any, nextStep: any, index: number, key: number) {
    const updatedDate = Moment(date).toDate().setHours(0, 0, 0, 0);

    if (key === 2) {
      const selectedDate = this.getStartOfDay(Moment(date).toDate());
      const { min, max } = this.getEvaluationDateRange();

      if (selectedDate < min || selectedDate > max) {
        return;
      }

      this.setState((previousState: any) => {
        let sections = [
          ...previousState.sections,
        ];
        sections[key] = {
          ...sections[key],
          date: date,
        };
        return { sections };
      });
      return;
    }

    if (
      (nextStep?.date && updatedDate > Moment(nextStep?.date).toDate().setHours(0, 0, 0, 0)) ||
      (previousStep?.date && index !== 1 && updatedDate < Moment(previousStep?.date).toDate().setHours(0, 0, 0, 0))
    ) return;

    this.setState((previousState: any) => {
      let sections = [
        ...previousState.sections,
      ];
      sections[key] = {
        ...sections[key],
        date: date,
      };
      return { sections };
    });
  }

  render() {
    if (this.state.loading) return <Loading show={this.state.loading} />;
    return (
      <div className="container">
        <Row className="container mt-4 d-flex align-items-center justify-content-between">
          <span className="h3 u-semibold">
            {t("Candidatura")}: {this.state.opportunity.titulo}
          </span>
          <span className="u-fs-sm u-semibold">
            Status:{" "}
            {this.state.opportunity.isFinished
              ? t("Finalizada")
              : this.state.opportunity.isPublic
                ? t("Publicada")
                : t("Não publicada")}
            &nbsp;|&nbsp;
            {t("Etapa")}:{" "}
            {this.getOpportunityStep(this.state.opportunity.fase)} |{" "}
            {t("Ativa em")}: {Moment(this.state.calendarDateStart).format("DD/MM/YYYY")} |
            ID: {this.state.opportunity?.idOpportunity}
          </span>
        </Row>
        <Row className="container mt-4 d-flex align-items-center justify-content-between">
          <span className="u-fs-sm u-semibold">
            Recrutador responsável: {this.state.recruiter.displayName} | Data de candidatura: {Moment(this.state.dataCandidatura).format("DD/MM/YYYY")}
          </span>
        </Row>
        <hr style={{ borderColor: "#E1E4E7" }} />
        <Row className="mt-4 d-flex align-items-center">
          <Col xl={4} lg={12} md={12} sm={12}>
            <div className="professional-title d-flex align-items-center mb-2">
              {/* Imagem do candidato */}
              <img
                src={
                  this.state.user.userImageUrl &&
                    this.getNewFileStackUrl(this.state.user.userImageUrl)
                    ? this.setUrlImg(this.state.user.userImageUrl)
                    : this.state.user.userImageUrl
                      ? this.state.user.userImageUrl
                      : (ReactComponents)
                }
                alt={this.state.user.displayName}
                className="profile-image" // Adiciona estilização caso necessário
              />

              {/* Nome do candidato ao lado da imagem */}
              <div className="professional-info ml-3">
                <Link
                  to={`/professional/${this.state.user._id}`}
                  className="h4 u-semibold mb-0"
                >
                  {this.state.user.displayName}
                </Link>
              </div>
            </div>
            {/* E-mail abaixo da imagem e do nome */}
            <p className="u-fs-md text-muted">{this.state.user.email}</p>
          </Col>

          {!(this.state.status.id === 6 || this.state.status.id === 5 || this.state.status.id === 4) && <Col xl={2} />}
          <Col className="mt-4" xl={2} lg={12} md={12} sm={12}>
            <ThemeProvider theme={theme as any}>
              <Dropdown
                selectedItem={this.state.capture}
                onSelect={(value) =>
                  this.setState({
                    capture: value,
                  })
                }
                downshiftProps={{
                  itemToString: (item: OpportunityFields) => item && item.value,
                }}
              >
                <FieldDropdown>
                  <Label style={{ fontWeight: 400 }}>{t("Fonte do Candidato")}:</Label>
                  <Select>{this.state.capture?.value}</Select>
                </FieldDropdown>
                <Menu>
                  {OpportunityCapture.map((option) => (
                    <Item key={option.id} value={option}>
                      {t(option.value)}
                    </Item>
                  ))}
                </Menu>
              </Dropdown>
            </ThemeProvider>
          </Col>
          <Col className="mt-4" xl={2} lg={12} md={12} sm={12}>
            <ThemeProvider theme={theme as any}>
              <Dropdown
                selectedItem={this.state.source}
                onSelect={(value) =>
                  this.setState({
                    source: value,
                  })
                }
                downshiftProps={{
                  itemToString: (item: OpportunityFields) => item && item.value,
                }}
              >
                <FieldDropdown>
                  <Label style={{ fontWeight: 400 }}>{t("Canal")}:</Label>
                  <Select>{this.state.source?.value}</Select>
                </FieldDropdown>
                <Menu>
                  {OpportunitySource.map((option) => (
                    <Item key={option.id} value={option}>
                      {t(option.value)}
                    </Item>
                  ))}
                </Menu>
              </Dropdown>
            </ThemeProvider>
          </Col>
          <Col className="mt-4" xl={2} lg={12} md={12} sm={12}>
            <ThemeProvider theme={theme as any}>
              <Dropdown
                selectedItem={this.state.status}
                onSelect={(value) => {
                  if (this.state.fieldsLocked) {
                    return;
                  }
                  if (!this.getFinalStep(this.state.sections) && value.value === "Selecionado") {
                    AlertService.warn("Preencha todas as etapas para selecionar o candidato..");
                  }
                  this.setState({
                    status: value,
                  })
                }}
                downshiftProps={{
                  itemToString: (item: OpportunityFields) => item && item.value,
                }}
              >
                <FieldDropdown className="mb-1 filho-1">
                  <div className="d-flex justify-content-between">
                    <Label className="mt-2" style={{ fontWeight: 400 }}>{t("Status Candidato")}:</Label>
                    <span className="mb-2">
                      <Tooltip
                        type="light"
                        size="large"
                        content={
                          t(
                            `Mantenha esses campos atualizados!
                            Assim outros recrutadores podem acessar o status do profissional na tela do currículo.`
                          )
                        }
                      >
                        <TooltipInfo
                          style={{ fill: "var(--color-secundario)" }}
                          className="mt-2 ml-1"
                        />
                      </Tooltip>
                    </span>
                  </div>
                  <Select style={this.state.fieldsLocked ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}>{t(this.state.status.value)}</Select>
                </FieldDropdown>
                <Menu>
                  {OpportunityStatus.map((option) => (
                    <Item key={option.id} value={option}>
                      {t(option.value)}
                    </Item>
                  ))}
                </Menu>
              </Dropdown>
            </ThemeProvider>
          </Col>
          {(((this.state.status.id === 6 || this.state.status.id === 4) && this.getFinalStep(this.state.sections)) ||
            this.state.status.id === 5) && (
              <Col className="mt-4" xl={2} lg={12} md={12} sm={12}>
                {this.renderDateField(this.state.status.id === 6 ? "Data da Seleção" : "Data do Status")}
              </Col>
            )}
          {this.state.isInvalidDate && (
            <Col style={{ display: "flex", justifyContent: "end" }}>
              <Message validation="error" >
                {t("Você deve escolher uma data entre")} {`${Moment(this.state.sections[4]?.date).format("DD/MM/YYYY")} ${t("e")} ${Moment(new Date()).format("DD/MM/YYYY")}`}
              </Message>
            </Col>
          )}
        </Row>
        {(
          this.state.status.value === "Selecionado" ||
          this.state.status.value === "Recusou" ||
          this.state.status.value === "Desistiu"
        ) && (
            <Row className="mt-3 d-flex justify-content-end">
              <Col xl={8} lg={8} md={12} sm={12}>
                <Label>Detalhe do Status:</Label>
                <Editor
                  editorState={
                    typeof this.state.statusDetails === "object"
                      ? this.state.statusDetails
                      : EditorState.createEmpty()
                  }
                  wrapperClassName="wrapper"
                  editorClassName="pl-3 pr-3"
                  onEditorStateChange={(editorState: EditorState) => {
                    this.setState({ statusDetails: editorState });
                  }}
                  readOnly={this.state.fieldsLocked}
                />
              </Col>
            </Row>
          )}
        <div className="d-flex justify-content-end mt-4">
          {!(this.state.status.value === "Selecionado" && !this.getFinalStep(this.state.sections)) && (
            this.renderPrimaryButton(this.handleSaveButtonClick, "Salvar")
          )}
        </div>
        <Row className="mt-2">
          <Col xl={1} />
          <Col className="mt-4" xl={10} lg={12} md={12} sm={12}>
            <AccordionContainer
              expandable={true}
              collapsible={true}
              expandedSections={this.state.expandedItems}
              onChange={(expandedItems) =>
                this.setState({
                  expandedItems: Array.isArray(expandedItems)
                    ? expandedItems
                    : [expandedItems]
                })
              }
            >
              {({
                getHeaderProps,
                getTriggerProps,
                getPanelProps,
                expandedSections,
                disabledSections,
              }) => (
                <>
                  <div className="mb-4" style={{ width: "100%" }}>
                    {this.state.sections.map((item: any, index: number) => {
                      if (item.key === 0) return null;
                      const disabled = disabledSections.indexOf(index) !== -1;
                      const hidden = expandedSections.indexOf(index) === -1;
                      const info = getInfoStep(item.key);

                      let previousStepWithDate = {} as Steps;
                      let nextStepWithDate = {} as Steps;

                      for (let i = 0; i < this.state.sections?.length; i++) {
                        if (i < index && this.state.sections[i].date) {
                          previousStepWithDate = this.state.sections[i];
                          if (previousStepWithDate.date) {
                            previousStepWithDate.date = this.setTimeZoneDefaut(new Date(previousStepWithDate.date));
                          }
                        }
                        if (i > index && this.state.sections[i].date && !nextStepWithDate.date) {
                          nextStepWithDate = this.state.sections[i];
                          if (nextStepWithDate.date) {
                            nextStepWithDate.date = this.setTimeZoneDefaut(new Date(nextStepWithDate.date));
                          }
                        }
                      }

                      const evaluationDateRange = this.getEvaluationDateRange();
                      const previousStepDate = previousStepWithDate.date
                        ? Moment(previousStepWithDate.date).toDate()
                        : undefined;
                      const nextStepDate = nextStepWithDate.date
                        ? Moment(nextStepWithDate.date).toDate()
                        : undefined;
                      const minDate = item.key === 2
                        ? evaluationDateRange.min
                        : previousStepDate || Moment(this.state.calendarDateStart).toDate();
                      const maxDate = item.key === 2
                        ? evaluationDateRange.max
                        : nextStepDate;

                      return (
                        <div key={item._id} id={`step-${index}`}>
                          <div
                            {...getHeaderProps({ role: null, ariaLevel: null })}
                          >
                            <button
                              type="button"
                              className="mt-2"
                              {...getTriggerProps({
                                index,
                                role: null,
                                tabIndex: null,
                                disabled,
                                style: {
                                  width: "100%",
                                  padding: ".75rem",
                                  border: "none",
                                  borderRadius: "4px",
                                  textAlign: "inherit",
                                  background:
                                    "var(--color-primary) 0% 0% no-repeat padding-box",
                                  boxShadow: "2px 2px 6px #00000029",
                                },
                              })}
                            >
                              <Row className="container m-0 p-0">
                                <Col className="d-flex justify-content-between pr-2">
                                  <span
                                    className="step-title"
                                    style={info?.sectionColor}
                                  >
                                    {info?.sectionTitle}
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <span className="section-step">
                                      {info?.sectionStep}
                                    </span>
                                    {item.meetsTheRequirements === 0 || item.isChecked ? (
                                      <span className="user-icon">
                                        <UserIcon style={{ opacity: 1, fill: "var(--color-secundario)" }} />
                                      </span>
                                    ) : (
                                      <Field
                                        className="ml-4"
                                        style={{ width: "20px" }}
                                      />
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </button>
                          </div>
                          <section
                            className="sectionStep"
                            {...getPanelProps({
                              index,
                              role: null,
                              hidden,
                            })}
                          >
                            <Row>
                              <Col xl={7} lg={6} md={6} sm={12}>
                                <Field className="mt-2 d-flex align-items-center">
                                  <Label className="accordion-font mr-3">
                                    {info?.professionalStep}
                                  </Label>
                                  <ThemeProvider theme={theme as any}>
                                    <ToggleField className="d-flex toggle-candidate">
                                      <Label className="accordion-font mr-2">
                                        {t("Não")}
                                      </Label>
                                      <Toggle
                                        onChange={(event) =>
                                          this.updateSectionItem(
                                            item.key,
                                            {
                                              meetsTheRequirements: event.target.checked ? 0 : 1
                                            }
                                          )
                                        }
                                        checked={
                                          item.meetsTheRequirements === 0
                                        }
                                      >
                                        <Label className="home-office">
                                          {/* <span className="accordion-font"> */}
                                          {/* {t("Sim")} */}
                                          {/* </span> */}
                                        </Label>
                                      </Toggle>
                                      <Label className="accordion-font">
                                        {t("Sim")}
                                      </Label>
                                    </ToggleField>
                                  </ThemeProvider>
                                </Field>
                                {item.key === 2 && this.renderEvaluationTypeField(item)}
                              </Col>
                              <Col xl={3} lg={6} md={6} sm={8}>
                                <Field className="d-flex align-items-center">
                                  <Label
                                    className="mt-2 mr-2 accordion-font"
                                    style={{
                                      flexShrink: 0,
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    {item.key === 2
                                      ? t("Data da Entrevista")
                                      : t("Data do Registro")}
                                  </Label>
                                  <Datepicker
                                    minValue={minDate}
                                    maxValue={maxDate}
                                    onChange={(date) => this.changeDate(date, previousStepWithDate, nextStepWithDate, index, item.key)}
                                    value={
                                      (item.date && Moment(item.date).toDate())
                                    }
                                    formatDate={(date) =>
                                      dateFormatter.format(date)
                                    }
                                    placement="end-top"
                                    locale="pt-BR"
                                    isCompact
                                  >
                                    <Input isCompact />
                                  </Datepicker>
                                </Field>
                              </Col>
                              <Col xl={2} lg={12} md={12} sm={12} />
                            </Row>
                            <Row className="mt-2">
                              <Col xl={10} lg={12} md={12} sm={12}>
                                <Editor
                                  editorState={item.details}
                                  wrapperClassName={"wrapper"}
                                  editorClassName={"pl-3 pr-3"}
                                  onEditorStateChange={(event) => {
                                    this.updateSectionItem(item.key, { details: event });
                                  }}
                                />
                              </Col>
                              <Col
                                className="mt-auto pt-2 d-flex justify-content-between"
                                xl={2}
                                lg={2}
                                md={2}
                                sm={2}
                              >
                                {this.renderSecondaryButton(() => this.changeStepCandidate(item.key), "Salvar")}
                                {this.renderTextButton(() => this.clear(item.key), "Limpar")}
                              </Col>
                            </Row>
                          </section>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </AccordionContainer>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (store: any) => ({
  filter: store.reportsFilterReducer.filter,
  startDateFilter: store.reportsFilterReducer.startDateFilter,
  endDateFilter: store.reportsFilterReducer.endDateFilter,
  mediaFilter: store.reportsFilterReducer.mediaFilter,
});

export default connect(mapStateToProps)(OpportunityProgress);
